import React from 'react'
import classnames from 'classnames/bind'

import Triangle from 'components/shared/Triangle'
import Image from 'components/shared/Image'
import Layout from 'components/shared/Layout'
import Separator from 'components/shared/Separator'
import GradientHeader from 'components/shared/GradientHeader'
import FeaturesList from 'components/shared/FeaturesList'
import LabelTitleText from 'components/shared/LabelTitleText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const LargeFeaturesSlice = ({
  gradientHeader,
  intro,
  asideImage,
  mainFeatures,
  extraFeatures,
  className,
}) => {
  return (
    <div className={cx(css.LargeFeaturesSlice, className)}>
      <Layout className={cx({ withImage: asideImage })} type="maxWidth">
        <div className={css.imageWrapper}>
          {asideImage && (
            <Image format={null} className={css.image} {...asideImage} />
          )}
          <Triangle
            className={css.triangle}
            type={asideImage ? 'top-right' : 'bottom-right'}
          />
        </div>
        <GradientHeader {...gradientHeader} className={css.header}>
          <div className={css.headerWrapper}>
            {intro && (
              <LabelTitleText
                className={css.content}
                textProps={{ size: 'big' }}
                {...intro}
              />
            )}
          </div>
        </GradientHeader>
        <Layout type="wrapper">
          <Layout type="mobileInnerWrapper">
            {mainFeatures && (
              <FeaturesList className={css.features} {...mainFeatures} />
            )}
            {extraFeatures && (
              <>
                <Separator className={css.separator} />
                <Layout type="wrapper" className={css.extraFeaturesWrapper}>
                  <FeaturesList {...extraFeatures} />
                </Layout>
              </>
            )}
          </Layout>
        </Layout>
      </Layout>
    </div>
  )
}

export default LargeFeaturesSlice
